import { useIsMutating } from '@/api/hooks';
import { type FormInstance, Modal, SubmitButton } from '@/components';
import type { BulkRoleFormSchema } from '@/features/tenant-manager/role/_models/role';
import { type FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { BulkRoleForm } from './BulkRoleForm';

type FormValues = z.infer<typeof BulkRoleFormSchema>;
type Props = {
  open: boolean;
  onSubmit: (values: FormValues) => void;
  onCancel: () => void;
};
export const BulkRoleFormModal: FC<Props> = ({ open, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const ref = useRef<FormInstance>(null);
  const mutationCount = useIsMutating();
  return (
    <Modal
      centered
      open={open}
      width={800}
      title={t('title-bulk-role')}
      onOk={() => {
        ref.current?.submit();
      }}
      footer={
        <SubmitButton
          text={t('set-in-bulk')}
          onClick={() => ref.current?.submit()}
          loading={mutationCount > 0}
        />
      }
      onCancel={onCancel}
      destroyOnClose
    >
      <BulkRoleForm ref={ref} onSubmit={onSubmit} />
    </Modal>
  );
};
